import { request } from './apiClient';
import { getSessionClientId } from './authSession';

const onlyDigits = (value) => value ? String(value).replace(/\D/g, '') : null;

// Monta o payload de contato (camelCase) resolvendo o cliente da sessão quando não informado.
export const buildContatoPayload = (formData, effectiveClientId) => ({
  nomeCompleto: (formData.nome || formData.nomeCompleto || '').trim(),
  numrCpf: onlyDigits(formData.cpf || formData.numrCpf || formData.numr_cpf),
  numrTelefone: onlyDigits(formData.telefone || formData.numrTelefone),
  enderecoEmail: (formData.enderecoEmail || '').trim(),
  idCliente: effectiveClientId || getSessionClientId() || null,
});

// Lista todos os contatos.
export const getContato = async (idCliente) => {
  const effectiveClientId = idCliente || getSessionClientId();
  return await request(`/api/contato?idCliente=${effectiveClientId}`);
};

// Cria um contato; retorna { response, payload }.
export const createContato = async (formData, effectiveClientId) => {
  const payload = buildContatoPayload(formData, effectiveClientId);

  const response = await request('/api/contato', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza o contato por id; retorna { response, payload }.
export const updateContato = async (id, formData, effectiveClientId) => {
  const payload = buildContatoPayload(formData, effectiveClientId);
  payload.idContato = Number(id);

  const response = await request(`/api/contato/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui o contato por id.
export const deleteContato = async (id) => {
  return await request(`/api/contato/${id}`, {
    method: 'DELETE'
  });
};
